import React, { useState } from 'react';

import PaperContainer from 'ui/PaperContainer';
import ButtonsForm from 'ui/form/ButtonsForm';

import { ServiceStatus, Actions } from '../../../consts';
import { getServiceStatus } from '../../../utils';
import Status from '../../common/Status';
import { HelpLink } from '../Forms';

const MODE_EDIT = 'edit';
const MODE_VIEW = 'view';

export default function Authenticate({
    config,
    service,
    onAction,
    editable,
    components,
}) {
    const [mode, setMode] = useState(MODE_VIEW);
    if (mode === MODE_VIEW) {
        const onEdit = () => setMode(MODE_EDIT);
        const status = getServiceStatus(config, service);
        return (
            <PaperContainer title="Authenticate" headerOut>
                <Status status={!!(status & ServiceStatus.ENABLED)} />
                <img
                    style={{ maxWidth: '80%' }}
                    src={config.logo}
                    alt={config.label}
                />
                <ButtonsForm withLeft>
                    <HelpLink config={config} />
                    {editable && (
                        <ButtonsForm.BackButton label="Edit" onClick={onEdit} />
                    )}
                </ButtonsForm>
            </PaperContainer>
        );
    } else {
        const onVerify = values => onAction(Actions.VERIFY, values);
        const onSave = values => {
            onAction(Actions.UPDATE, values);
            setMode(MODE_VIEW);
        };
        const onRemove = () => onAction(Actions.REMOVE);
        const onCancel = () => setMode(MODE_VIEW);
        return (
            <components.CredentialsView
                service={service}
                context={{ config }}
                onSave={onSave}
                onVerify={onVerify}
                onCancel={onCancel}
                onRemove={onRemove}
            />
        );
    }
}
